<section class="bg-top bg-cover bg-no-repeat custom-section-bg"
         [ngClass]="backgroundImgColor === 'green' ? 'section-energo-green' : 'section-energo-green'"
         [ngClass]="backgroundImgColor === 'orange' ? 'section-energo-orange' : 'section-energo-green'">

    <div class="flex flex-wrap h-full w-full lg:mx-16 xl:mx-32 mb-4 md:mb-0 items-center justify-center px-2">
        <p class="container px-auto font-bold text-white text-2xl md:text-4xl leading-normal lg:mx-0 lg:text-start">{{ headerTitle }}</p>
    </div>
</section>
